export default __webpack_public_path__ + "static/favicon-8a9a164797474231023a527c55db1e69.ico";